import { Pulse } from '@phosphor-icons/react';

export default Pulse;
